import { SvgMaison1mur, SvgMaison2murs, SvgMaisonR1, SvgMaisonSeule } from "components/svg";

export const MITOYENNETE_ITEMS = [
    {
        value: 0,
        code: 0,
        label: '0_WALL',
        icon: <SvgMaisonSeule />
    },
    {
        value: 1,
        code: 1,
        label: '1_WALL',
        icon: <SvgMaison1mur />
    },
    {
        value: 2,
        code: 2,
        label: '2_WALLS',
        icon: <SvgMaison2murs />
    },
];

export const LEVEL_ITEMS = [
    {
        value: 0,
        code: 0,
        label: '0_LEVEL',
        icon: <SvgMaisonSeule />
    },
    {
        value: 1,
        code: 1,
        label: '1_LEVEL',
        icon: <SvgMaisonR1 />
    },
];